export const LIST_OF_MARKETS_DETAILS = 'listOfMarketsDetails';
export const MARKET_SIZING_DETAILS = 'marketSizingDetails';
export const RELATED_MARKETS_DETAILS = 'relatedMarketsDetails';
